import cn from 'classnames';
import React from 'react';

import { ICommonAddress } from '../../types/shipping';

import styles from './CompactOrgAddressView.module.scss';

interface IProps {
  row: ICommonAddress & { label?: string };
  className?: string;
  addressClassName?: string;
  isMultiline?: boolean;
}

function CompactOrgAddressView({ row, className, addressClassName, isMultiline }: IProps) {
  const { label, company_name, address1, address2, city, state, zip, country } = row;
  const textClassName = isMultiline ? styles.multiline : styles.truncated;

  return (
    <div className={cn(styles.container, className)}>
      {row.label && <div className={textClassName}>{label}</div>}
      <div className={styles.content}>
        <div className={cn(styles.address, textClassName, addressClassName)}>
          {row.company_name && <span>{`${company_name}, `}</span>}
          {row.address1 && <span>{`${address1} `}</span>}
          {row.address2 && <span>{`${address2}, `}</span>}
          {row.city && <span>{`${city}, `}</span>}
          {row.state && <span>{`${state}, `}</span>}
          {row.zip && <span>{`${zip}, `}</span>}
          {row.country && <span>{country}</span>}
        </div>
      </div>
    </div>
  );
}

export default CompactOrgAddressView;
